import { useEffect } from 'react';

type HackyOnChangeClientEventDetails = {
    newClientId: string;
};

export class HackyOnChangeClientEvent extends CustomEvent<HackyOnChangeClientEventDetails> {
    public static readonly EventName = 'hackyOnChangeClient';

    public constructor(newClientId: string) {
        super(HackyOnChangeClientEvent.EventName, { detail: { newClientId } });
    }

    public static useSubscribe(listener: (event: HackyOnChangeClientEvent) => void): void {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
            document.addEventListener(HackyOnChangeClientEvent.EventName, listener as any);
            return () => {
                document.removeEventListener(HackyOnChangeClientEvent.EventName, listener as any);
            };
        }, [listener]);
    }

    public static publish(event: HackyOnChangeClientEvent): void {
        /*
         * This is hacky because of the angular/left nav design
         * DO NOT repeat this unless you absolutely need to
         */
        document.dispatchEvent(event);
    }
}
